import { AUTH_ENDPOINT } from "Constants";
import type {
  LoginRequest,
  LoginResponse,
  OidcLoginRequest,
  OidcLoginResponse,
} from "Pages/login";
import { baseApi } from "Services";
import { resetStoreThunk } from "Utils";

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => {
        const data = new FormData();

        data.append("email", credentials.email);
        data.append("password", credentials.password);

        return {
          url: `${AUTH_ENDPOINT}/login`,
          method: "POST",
          body: data,
        };
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(resetStoreThunk());
        } catch {
          return;
        }
      },
      invalidatesTags: ["Whoami"],
    }),
    oidcLogin: build.mutation<OidcLoginResponse, OidcLoginRequest>({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/sso/oidc/login`,
        method: "POST",
        body: queryArg.oidcSsoLoginBody,
      }),
      invalidatesTags: ["SSO"],
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useOidcLoginMutation } = authApi;
